import {
    userInfo
} from "os";

export const rawMixins = {
    data() {
        return {
            months: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            jSonData: []
        }
    },
    methods: {
        getKeyIndex(data, searchKey) {
            // this.isloading = true;
            // console.log("searchKey", searchKey, typeof searchKey);
            var ind;
            this.rawData.forEach(function (val, index) {
                // console.log("getkey", typeof val.value, (val.value == searchKey), val, index);
                if (val.coname == searchKey) {
                    // console.log("Matched", val, index);
                    ind = index;
                }
            });
            // this.isloading = false;
            return ind;
        },
        checkIfChecked(data, val) {
            return data.includes(val);
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/mixins/rawMixins.js